// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__21vUp","buttons":"SendReceipts_buttons__3VnVT","email":"SendReceipts_email__AHVx5","bookApptTitle":"SendReceipts_bookApptTitle__3k2on"};